/**
 * <Email
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { Component } from 'react';
import SalaryModal from 'template/Modals/Salary';
import locale from './locale';
import './SalaryCalculator.scss'



class SalaryCalculator extends Component {

  openSalaryModal(){
    SalaryModal({attendanceDetail: this.props.attendance, salaryCalculatorType: this.props.salaryCalculatorType})
    .then(({data})=>{
      if(data) {
        this.props.setTotalSalary(data);
      } else {
        this.props.resetTotalSalary();
      }
    })
    .catch((e) => {})
  }

  render(){
    const {teacherInfo} = this.props;

    return(
      <div className='container-fluid'>
        <div className='salary-section'>
          <div className='row'>
            <div className='salary-section-label col-xs-1'>{__('Total Salary', locale)}:</div>
            <div className='salary-section-content col-xs-2'>${this.props.attendance.totalSalary === 0? '0.00': this.props.attendance.totalSalary}</div>
            <div className='salary-section-tip col-xs-6'>{__('The calculated salary will not be saved to our system, please export it after the calculation', locale)}</div>
            <button className='btn btn-primary pull-right salary-btn' disabled={teacherInfo.archived} onClick={()=>this.openSalaryModal()}>{__('Calculate Salary', locale)}</button>
          </div>
        </div>
      </div>
    )
  }
}

export default SalaryCalculator;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/SalaryCalculator/index.js